// extracted by mini-css-extract-plugin
export default {"buttons":"report-template_buttons__fce-m","actions":"report-template_actions__is4nG"};